import { get, set, del } from "idb-keyval";

export class procollegeStore {
  static CACHE_PREFIX = "ProCollegeStore";

  // Хелпер для формирования ключа
  #getFullKey(key) {
    return `${procollegeStore.CACHE_PREFIX}:${key}`;
  }

  async get(key) {
    const item = await get(this.#getFullKey(key));

    if (!item) return null;

    // Проверяем срок годности
    if (item.expiresAt !== 0 && Date.now() > item.expiresAt) {
      await this.remove(key);
      return null;
    }

    return item.data;
  }

  async remove(key) {
    await del(this.#getFullKey(key));
  }
  //one week ttl
  async set(key, data, ttl = 604800000) {
    const expires =
      ttl !== false && Number.isFinite(+ttl) ? Date.now() + ttl : 0;

    //vue reactive to raw
    const cleanData = JSON.parse(JSON.stringify(data));
    // Сохраняем объект напрямую, idb-keyval сама его сериализует
    await set(this.#getFullKey(key), {
      data: cleanData,
      expiresAt: expires,
    });
  }
}
